import qs from "qs";
import { useLocation } from "react-router";

export function useQueryString() {
    const location = useLocation();
    return qs.parse(location.search, { ignoreQueryPrefix: true });
}
